<template>
  <div>
    <div class="header">
      <el-image class="logo" :src="logo" mode="heightFix"></el-image>
      <!-- <el-image class="logo logo-white" :src="logoWhite" mode="heightFix"></el-image> -->
      <div class="flex">
        <div class="cz flex" style="align-items: center;">
          <div class="headertips">
            <span class="wcz"></span>
            <span class="headerstatus">未操作</span>
          </div>
          <div class="headertips">
            <span class="jxz"></span>
            <span class="headerstatus">进行中</span>
          </div>
          <div class="headertips">
            <span class="ywc"></span>
            <span class="headerstatus">已完成</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="star" v-if="userInfor.audit_status==4">
          <img class="star_bell" src="../assets/star.png" alt="">
          <div class="star_text">正式会员</div>
        </div>
        <!--        v-if="userInfor.audit_status==4&& expire"-->
        <div class="xfBox" v-if="userInfor.audit_status==4" @click="membershipRenewal">会员续费</div>
        <!--        <img class="bell" src="../assets/bell.jpg" alt="">-->

        <el-dropdown trigger="click" placement="top"  @command="handleCommand">
          <div class="username">
            <div>
              登录名：{{ userInfor.mobile }}
            </div>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="dropdown_item">修改密码</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!--        <div class="border">公司：{{ userInfor.name_cn }}</div>-->
        <div class="pointer logout" @click="logout">
          退出
          <el-image
              class="ex-image"
              :src="exitIcon"
              style="width: 18px; height: 18px; margin-left: 5px"
          ></el-image>
        </div>
      </div>
    </div>
    <el-dialog
        :visible.sync="paymentDialogShow"
        title="会员续费"
        class="header-dialog"
        width="750px"
        :lockScroll="false"
        :modal-append-to-body="false"
        :close-on-click-modal="false">
      <payment :payment_title="payment_title"></payment>
    </el-dialog>

    <el-dialog
        :close-on-click-modal="false"
        title="修改密码"
        :visible.sync="dialogVisible"
        width="440px"
    >
      <el-form :model="forget_form" :rules="forget_form_rules" ref="forget_form_ref">
        <el-form-item prop="account">
          <el-input disabled type="text" v-model="forget_form.account" auto-complete="off"
                    placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item prop="img_code" class="verification">
          <el-input type="text" v-model="forget_form.img_code" auto-complete="off"
                    placeholder="请输入右侧验证码">
              <span slot="suffix" style="height: 75px;line-height: 75px">
              <img style="cursor: pointer; width: 130px;margin: 5px 0" :src="image" title="验证码点击刷新"
                   alt="点击刷新" @click="getImg_code"/>
              </span>
          </el-input>
        </el-form-item>
        <el-form-item prop="sms_code" class="verification">
          <el-input type="text" v-model="forget_form.sms_code" auto-complete="off"
                    placeholder="请输入验证码">
              <span slot="suffix">
           <span
               style="font-weight: 400;font-size: 14px;color: #1677FF;line-height: 52px; cursor: pointer;"
               v-if="countdown==60"
               @click="getFlag('ZHDLMM',forget_form)">获取验证码</span>
              <span v-else style="font-weight: 400;font-size: 14px;line-height: 52px;">已发送（{{ countdown }}s）</span>
              </span>

          </el-input>
        </el-form-item>
        <el-input type='text' v-model="password" auto-complete="off"
                  placeholder="请输入密码" style="position: absolute; width: 10px; z-index: -9999999">
        </el-input>
        <el-input :type="passwordShow" show-password v-model="password" auto-complete="off"
                  placeholder="请输入密码" style="position: absolute; width: 10px; z-index: -9999999">
        </el-input>
        <el-form-item prop="password">
          <el-input :type="passwordShow" show-password v-model="forget_form.password" auto-complete="off"
                    placeholder="请输入密码">
          </el-input>
        </el-form-item>
        <el-form-item prop="password_confirm">
          <el-input :type="passwordShow" show-password v-model="forget_form.password_confirm" auto-complete="off"
                    placeholder="请再次输入密码">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button :disabled="submitDisabled" type="primary" @click="forgotPasswd('forget_form_ref')">确 定</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import {getVerify, Login_forgotPasswd, Login_sendCode, logOut, paymentByYear, submitCompanyInfo} from "@/api/api";
import payment from '../views/payment.vue';
import {Message} from "element-ui";

export default {
  components: {payment},
  data() {
    return {
      password: '',//假的
      submitDisabled: false,//
      payment_title: '',
      logo: require("../assets/logo.jpg"),
      exitIcon: require("../assets/exit_1.jpg"),
      userInfor: JSON.parse(localStorage.getItem("userdata")),
      nowTime: new Date().getTime(),
      expire: false,
      paymentDialogShow: false,
      dialogVisible: false,
      forget_form: {
        account:'',
        img_code:''
      },
      passwordShow: 'password',
      image: '',
      ruleForm: {
        type: '1',
        scene: '1',
        account: '',
        password: '',
        terminal: 4,
        sms_code: 12345,
      },
      countdown: 60,
      forget_form_rules: {
        account: [{required: true, message: "请输入手机号", trigger: "blur"}, {
          pattern: /^1[3-9]\d{9}$/,
          message: "手机号码格式不正确",
          trigger: "blur",
        },],
        sms_code: [{required: true, message: '请输入验证码', trigger: 'blur'}],
        password: [{required: true, message: '请输入密码', trigger: 'blur'}],
        password_confirm: [{required: true, message: '请再次输入密码', trigger: 'blur'}],
      }
    };
  },
  mounted() {
    setTimeout(() => {
      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let date = new Date(userdata.due_time);
      let timestamp = date.getTime()
      let due_time = Number(timestamp)
      var date3 = (due_time - this.nowTime) / 1000;
      // 两个月时间     24*60*3600
      this.expire = date3 <= 24 * 30 * 3600;
      let time = this.timestampToDateString(timestamp)
      this.payment_title = `您的会员将于${time}到期，请及时续费。`
    }, 1000);
    this.getImg_code()
  },
  created() {
  },
  methods: {
    submitCompanyInfo,
    handleCommand(){
       this.forget_form.account= this.userInfor.mobile
        this.dialogVisible = true;
    },
    getImg_code() {
      getVerify().then(res => {
        if (res.code == 1) {
          this.image = res.data.img
        } else {
          Message.error(res.msg);
        }
      })
    },
    getFlag(scene, form) {
      if (form.account.length > 0 && form.img_code.length > 0) {
        // const dis = await this.checkCaptcha()
        // if (dis) {
        let data = {
          scene: scene,
          img_code: form.img_code,
          mobile: form.account,
        }
        Login_sendCode(data).then(res => {
          if (res.code == 1) {
            Message.success('验证码发送成功，请注意查收')
            this.timer()
          } else {
            this.forget_form.img_code = ''
            this.getImg_code()
          }
        })
        // }
      } else {
        Message.error('请填写手机号及图片验证码');
      }
    },
    // 计时器
    timer() {
      if (this.countdown < 0) {
        this.countdown = 60
        return
      }
      setTimeout(() => {
        this.countdown = this.countdown - 1
        this.timer();
      }, 1000);
    },
    forgotPasswd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submitDisabled = true;
          let params = this.forget_form
          params.type = this.ruleForm.type
          params.scene = "ZHDLMM"
          Login_forgotPasswd(params).then((res) => {
            this.submitDisabled = false;
            if (res.code == 1) {
              this.forget_form = {}
              Message.success(res.msg);
              this.dialogVisible = false
              localStorage.removeItem('Flag');
              setTimeout(()=>{
                this.go_login()
              },1000)

            }
          }).catch((err) => {
            this.submitDisabled = false;
            console.log(err);
          });

        }
      })

    },


    timestampToDateString(timestamp) {
      if (timestamp) {
        let num = Number(timestamp)
        const date = new Date(num);
        return date.toLocaleDateString().replaceAll('/', '-')
      } else {
        return ''
      }
    },
    //赵 跳转到会员续费页面
    async membershipRenewal() {
      const res = await paymentByYear()
      if (res.code == 1) {
        this.$nextTick(() => {
          this.paymentDialogShow = true;
        })
      } else if (res.code == 0) {
        this.$message.warning(res.msg);
      }
      // if(this.userInfor.audit_status!=4) return  this.$message.warning('非正式会员不能续费');

    },
    logout() {
      this.$confirm("确定要退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
           this.go_login()
          })
          .catch(() => {
            // this.$message({
            //     type: "info",
            //     message: "已取消删除",
            // });
          });
    },

    // 退出
    go_login(){
      logOut()
          .then((res) => {
            console.log(res, "======退出");
            if (res.code == 1) {
              let loginRes = {
                token: null,
                isLogin: false,
              };
              this.$store.commit("userStatus", loginRes);
              localStorage.clear();
              // 状态保持清除后刷新页面
              window.location.reload();
              this.$router.push({
                path: "/login",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
    }
  },
};
</script>

<style lang="scss">
.change_password{



} .el-form-item__content {
      display: flex;
    }

 .el-input__inner {
    height: 52px !important;
  }
.dialog-footer{
  text-align: center;
}
.xfBox {
  padding: 0 !important;
  width: 88px;
  height: 32px;
  background: #F7A1A9;
  line-height: 32px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
}

.bell {
  width: 20px;
  height: 20px;
  margin-left: 40px;

}

.star {
  text-align: center;
}

.star_bell {
  width: 25px;
}

.star_text {
  font-size: 10px;
  color: #ffffff;
}

.headerstatus {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
}

.headertips {
  margin-right: 40px;
  display: flex;
  align-items: center;
}

.headertips span:nth-child(1) {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 10px;
}

.wcz {
  background: #c0c4cc;
  border: 1px solid rgba(255, 255, 255, 0.88);
}

.jxz {
  background: #ffb800;
  border: 1px solid rgba(255, 255, 255, 0.88);
}

.ywc {
  //background: #52C41A;
  background: #E40080;
  border: 1px solid rgba(255, 255, 255, 0.88);
}

.cz {
  margin-left: 76px;
}

.header {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px 0 30px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  background: #E40080;
  z-index: 19999;

  .logo {
    width: 150px;
    // height: 62px;
    // line-height: 62px;
    text-align: center;
    margin-left: 38px;
  }

  .username {
    cursor: pointer;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    line-height: 40px;

    .el-icon-arrow-down {
      position: absolute;
      bottom: -6px
    }

  }
 // .dropdown_item {
 //   background-color: #ecf5ff;
 //   color: #E40080 !important;
 // }
 ///deep/.el-dropdown-menu__item:not(.is-disabled):hover {
 //   color: #E40080 !important;
 //   background-color: #ecf5ff;
 // }
  .border {
    color: #fff;
  }

  .logo-white {
    display: none;
  }

  .header-title {
    font-size: 30px;
    font-weight: bold;
    color: #2c2c2e;
    margin: 0 60px 0 60px;
  }

  .right {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 14px;

    > div {
      padding: 0 20px;
    }

    .message {
      position: relative;

      .message-tips {

        position: absolute;
        top: -4px;
        right: 15px;
        width: 16px;
        height: 16px;
        color: #fff;
        font-size: 12px;
        line-height: 16px;
        border-radius: 50%;
        text-align: center;
        background: #ff4d4f;
      }
    }

    .border {
      border-left: 1px solid #fff;
      border-top: 0 none;
      border-bottom: 0 none;
    }

    .pointer {
      cursor: pointer;
    }

    .logout {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 66px;
      height: 26px;
      padding: 0;
      transition: all 0.2s;
      color: #fff;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;

      .ex-image2 {
        display: none;
      }
    }

    .logout:hover {
      color: #fff;
      text-decoration: underline;

    }
  }
}

.messagebtn {
  width: 146px;
  height: 40px;
  overflow: hidden;
  font-size: 16px;
  border: 0 none !important;
  background: #2c2c2e !important;
  border-radius: 5px;
}

.header-dialog .el-icon-close:hover {
  color: #E40080;
}

.header-dialog .el-dialog__header {
  padding-bottom: 0;
}

.header-dialog .el-dialog__body {
  padding-top: 0;
}

.header-dialog {
  overflow-y: hidden;
}

.header-dialog .el-dialog {
  margin-top: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media (max-width: 1366px) {
  .header-title {
    font-size: 24px !important;
    margin: 0 30px 0 34px !important;

  }
}

@media (max-width: 1024px) {
  .header-title {
    font-size: 20px !important;
    margin: 0 30px 0 34px !important;

  }
  .header .right > div {
    padding: 0px 9px;
  }

}

@media only screen and (max-width: 767px) {
  .header {
    height: 60px;
    padding: 0 18px 0 15px;
    background: #2c2c2e;
    justify-content: inherit;

    .header-title {
      display: none;

    }

    .cz {
      display: none;
    }

    .username {

      display: none;
      color: #fff;
    }

    .border {
      display: none;
    }

    .right {
      color: #fff;
      position: relative;
      justify-content: inherit;
      font-size: 12px !important;

      > div {
        padding: 0 6px;
      }

      .border {
        border-color: #fff;
      }

      .logout {
        color: #2c2c2e;
        position: absolute;
        right: 0;
      }
    }

    .logo {
      display: none;
    }

    .logo-white {
      width: 46px;
      // height: 30px;
      display: block;
    }
  }
}
</style>
